import React from "react";
import LeaveReasonGenerator from "./LeaveReasonGenerator";

function App() {
  return (
    <div className="min-h-screen bg-pink-100 flex items-center justify-center">
      <LeaveReasonGenerator />
    </div>
  );
}

export default App;
